var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7656 0C13.9263 0 14.0805 0.0641302 14.1941 0.178283L17.6225 3.62159C17.8592 3.8593 17.8592 4.2447 17.6225 4.48241L6.48023 15.6731C6.40409 15.7496 6.30903 15.8043 6.20485 15.8317L1.56433 17.0491C1.35615 17.1037 1.13476 17.0433 0.982614 16.8905C0.830473 16.7377 0.770401 16.5154 0.824777 16.3063L2.0369 11.6456C2.06411 11.541 2.11859 11.4455 2.19474 11.369L13.337 0.178283C13.4507 0.0641302 13.6048 0 13.7656 0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7656 0C13.9263 0 14.0805 0.0641302 14.1941 0.178283L17.6225 3.62159C17.8592 3.8593 17.8592 4.2447 17.6225 4.48241L6.48023 15.6731C6.40409 15.7496 6.30903 15.8043 6.20485 15.8317L1.56433 17.0491C1.35615 17.1037 1.13476 17.0433 0.982614 16.8905C0.830473 16.7377 0.770401 16.5154 0.824777 16.3063L2.0369 11.6456C2.06411 11.541 2.11859 11.4455 2.19474 11.369L13.337 0.178283C13.4507 0.0641302 13.6048 0 13.7656 0Z",
    fill: "url(#paint0_linear_42_1451)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.909091 19.1739C0.407014 19.1739 0 19.5827 0 20.087C0 20.5912 0.407014 21 0.909091 21H19.0909C19.593 21 20 20.5912 20 20.087C20 19.5827 19.593 19.1739 19.0909 19.1739H0.909091Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.909091 19.1739C0.407014 19.1739 0 19.5827 0 20.087C0 20.5912 0.407014 21 0.909091 21H19.0909C19.593 21 20 20.5912 20 20.087C20 19.5827 19.593 19.1739 19.0909 19.1739H0.909091Z",
    fill: "url(#paint1_linear_42_1451)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_42_1451",
    x1: 9.97494,
    y1: 2.42742,
    x2: 9.97493,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4201FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9954F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_42_1451",
    x1: 9.97494,
    y1: 2.42742,
    x2: 9.97493,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4201FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9954F0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.98c0a85a452df09a7c6d99971a73e37a.svg";
export { ForwardRef as ReactComponent };